export const DELETE_TOOLTIP = "si.management.sf.settings_export.settings.table.btn.delete.label";

export const EXPORT_TAB_ACCOUNTS_TITLE = {
    salesforce: "si.management.integration.export.preferences.toggle.accounts",
    hubspot: "si.management.integration.export.preferences.toggle.companies",
    dynamics: "si.management.integration.export.preferences.toggle.accounts",
};

export const EXPORT_TAB_CONTACTS_TITLE = "si.management.integration.export.preferences.toggle.contacts";
export const EXPORT_TAB_LEADS_TITLE = "si.management.integration.export.preferences.toggle.leads";

export const NO_ACCESS_BTN = "si.management.integration.export.contacts.req.access.btn.text";

export const NO_ACCESS_TITLE = "si.management.integration.export.no.access.title";
export const NO_ACCESS_SUB_TITLE = "si.management.integration.export.contacts.req.access.title";

export const EXPORT_ADD_BUTTON_TITLE = "si.management.sf.settings_export.settings.btn.add_fields";
export const EXPORT_REQUEST_ACCESS_TITLE = "si.management.integration.export.request.access.title";
export const EXPORT_REQUEST_ACCESS_SUBTITLE = "si.management.integration.export.request.access.subtitle";

export const VALUE_NOT_DEFINED_ERROR = `si.management.integration.export.cell.example.crmNotDefined.error`;
export const PREDEFINED_NO_CRM_SELECTED = `si.management.integration.export.cell.example.predefined.noCrm.text`;
